import React, { Component } from 'react';

import 'react-bootstrap';
import { connect } from "react-redux";

import store from '../../../store/configureStore';
import Pagination from '../../../components/pagination/Pagination';
import { changeActiveItemAction } from '../../../actions/navAction';
import { changeTopBannerAction } from '../../../actions/topBannerAction';
import { Businesses, PagesForCaption, CaptionCodes } from '../../../config/Helper';
import DestinationAreaListBlock from './DestinationAreaListBlock';
import destinationApi from '../../../api/destinationApi';
import NoData from '../../../components/NoData';
import captionApi from '../../../api/captionApi';
import { lang } from '../../../config/lang';
import RightBar from '../RightBar/RightBar';
import ScrollToTop from '../../home/ScrollToTop/ScrollToTop';
class DestinationAreaList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            destinationArray: [],
            captionTitle: [],
            curPage: 1,
            pages: 0,
            deltaPage: 6,
            total: 0,
            sectionTitle: {},
        }
        this.business = Businesses.indexOf('destination');
        this.lang = props.language.lang_key;
        this.isloading = true;

        this.getDestinationArea = this.getDestinationArea.bind(this);
        this.getCaptions = this.getCaptions.bind(this);

    }

    componentWillMount() {
        this.getDestinationArea();
        store.dispatch(changeTopBannerAction({
            page: 'destination',
            showSearch: false,
            isHome: false
        }));
    }

    componentDidMount() {
        window.onSetClass('light');
        window.onClose();
        window.scrollTop('#top_banner');
    }

    componentDidUpdate() {
        window.image();
        window.playVideo();
        window.onClose();
    }

    componentWillUnmount() {

    }

    componentWillReceiveProps(newProps) {
        if (this.lang !== newProps.language.lang_key) {
            this.lang = newProps.language.lang_key;
            this.getDestinationArea();
        }
    }

    getDestinationArea() {
        this.isloading = true;
        destinationApi.getDestinationArea(this.state.curPage - 1).then((json) => {
            if (json.status === 200 && json.data) {
                this.isloading = false;
                // eslint-disable-next-line
                this.state.destinationArray = json.data.destinations;
                this.state.pages = Math.ceil(json.data.total / 8);
                this.state.total = json.data.total;
                this.getCaptions();
            } else {
                if (json.status === 620) {

                } else {

                }
            }
        });
        store.dispatch(changeActiveItemAction(Businesses.indexOf('destination')));
    }

    getCaptions() {
        captionApi.getCaptions('destinations').then((json) => {
            if (json.status === 200) {

                this.setState({
                    captionTitle: json.data,
                });
            } else {

            }
        })
    }

    onChangePage(page) {
        // eslint-disable-next-line
        this.state.curPage = page;
        this.getDestinationArea();
        window.scrollTop('#activity_section', 100);
    }

    render() {

        return (
            <div>
                <section className="ftco-section" id="destination_area_list">
                    {
                        (this.state.destinationArray.length === 0 && this.isloading === false) &&
                        <NoData />
                    }
                    <div className="container">
                        {/* <div className="row justify-content-center pb-3">
                            <div className="col-md-7 heading-section text-center">
                                <h2 className="mb-4">
                                    {this.state.captionTitle[CaptionCodes[PagesForCaption.indexOf('destinations')].indexOf('destinations_destination')] === undefined ?
                                        "" : this.state.captionTitle[CaptionCodes[PagesForCaption.indexOf('destinations')].indexOf('destinations_destination')].title}
                                </h2>
                                <p>{this.state.captionTitle[CaptionCodes[PagesForCaption.indexOf('destinations')].indexOf('destinations_destination')] === undefined ?
                                    "" : this.state.captionTitle[CaptionCodes[PagesForCaption.indexOf('destinations')].indexOf('destinations_destination')].description}</p>
                            </div>
                            <br />
                        </div> */}
                        <div className='text-center mb-3'>
                            {`${lang('total')}` + this.state.total}
                            </div>
                        <div className="row">
                            <div className="col-lg-12 pr-lg-12">
                                <div className="row">
                                    <div className="col-md-12">

                                        {
                                            this.state.destinationArray.map((destination, key) => (
                                                <div key={key} className="col-12 col-sm-3 col-md-3 col-lg-3 ftco-animate fadeInUp ftco-animated">
                                                    <DestinationAreaListBlock
                                                        id={destination.id}
                                                        image={destination.media_filename}
                                                        title={destination.title}
                                                        business={this.business}
                                                        media_type={destination.media_filetype}
                                                        cat='destination'
                                                    />
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="container">
                    <div className="row justify-content-center pb-5">
                        <div className="col-md-12 block-27 text-center">
                            {
                                <Pagination
                                    total={this.state.pages}
                                    curPage={this.state.curPage}
                                    visible={this.state.deltaPage}
                                    onChangePage={(page) => this.onChangePage(page)}
                                />
                            }
                        </div>
                    </div>
                </div>
                <ScrollToTop />
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        language: state.language
    };
}
export default connect(mapStateToProps)(DestinationAreaList);